import { makeStyles } from '@material-ui/core'
import React from 'react'
import { tokens } from './tokens'

const useStyles = makeStyles(() => ({
    btn: {
        display: 'inline-block',
        padding: '13px 30px',
        borderRadius: 6,
        fontWeight: 600,
        fontSize: '.95rem',
        letterSpacing: '.2px',
        border: '2px solid transparent',
        textDecoration: 'none',
        cursor: 'pointer',
        transition: `transform ${tokens.transition}, box-shadow ${tokens.transition}, background ${tokens.transition}, color ${tokens.transition}`,
    },
    primary: {
        background: tokens.colorPrimary,
        color: '#fff',
        boxShadow: tokens.shadowSm,
        '&:hover': {
            background: tokens.colorPrimaryDark,
            transform: 'translateY(-3px)',
            boxShadow: tokens.shadowMd,
            color: '#fff',
        },
    },
    light: {
        background: '#fff',
        color: tokens.colorPrimary,
        '&:hover': {
            transform: 'translateY(-3px)',
            boxShadow: tokens.shadowMd,
        },
    },
}))

export function Button({ variant = 'primary', href = '#', className = '', children, ...rest }) {
    const classes = useStyles()
    return (
        <a
            href={href}
            className={`${classes.btn} ${variant === 'light' ? classes.light : classes.primary} ${className}`}
            {...rest}
        >
            {children}
        </a>
    )
}
